// import React, { useEffect, useState } from "react";
// import Simple_product from "./Simple_product";

// const Home_page_prdoct1 = () => {
//   const Product = [{ src: 'tv-1024x1024.png', title: 'Televisions' }]
//   return (

//     <div class="container" style={{
//       borderRadius: "16px",
//       boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
//       backdropFilter: "blur(0.6px)",
//       WebkitBackdropFilter: "blur(0.6px)",
//       border: "1px solid rgba(255, 255, 255, 0.3)",
//       padding: '40px',
//       width: 'fit-content',
//       alignSelf: 'center'
//     }}>
//       <div class="row" style={{ width: '80vw' }}>
//         <div class="col-sm-6 col-md-4" style={{
//           borderRadius: "16px",
//           boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
//           backdropFilter: "blur(0.6px)",
//           WebkitBackdropFilter: "blur(0.6px)", // Note: React automatically handles vendor prefixes, but this is still used for clarity and compatibility
//           border: "1px solid rgba(255, 255, 255, 0.3)", padding: '30px',
//           marginLeft: '2% 0%'
//         }}>
//           <p style={{
//             background: 'linear-gradient(white, white) padding-box, linear-gradient(to right, rgb(255, 0, 0) 30px, rgb(0,0,0) 70%, rgba(255, 255, 255, 0.804)) border-box',
//             borderBottom: '2px solid transparent',
//             // borderTop: '2px solid transparent',
//             // borderTop: 'none',
//             borderLeft: 'none',
//             borderRight: 'none',
//             borderBottomRightRadius: '30px',
//             padding: '5px', fontSize: '.9rem', fontWeight: '400',
//           }}>Entertainment</p>
//           <div class="row">
//             <div class="col-md-6">
//               <Simple_product product={{ src: 'tv-1024x1024.png', title: 'Televisions', category: 'TV & Home Entertainment' }} />
//             </div>
//             <div class="col-md-6">
//               <Simple_product product={{ src: 'home-theatre-1024x1024.png', title: 'Home Theater', category: 'Home Theater' }} />
//             </div>

//           </div>
//           <div class="row">
//             <div class="col-md-6">
//               <Simple_product product={{ src: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/bluetooth-speaker-1536x1536.png', title: 'Audio Speakers', category: 'Speakers' }} />
//             </div>
//             <div class="col-md-6">
//               <Simple_product product={{ src: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/sound-bar-1-1536x1536.png', title: 'Soundbar', category: 'Soundbar' }} />
//             </div>

//           </div>
//         </div>
//         <div class="col-sm-6 col-md-4" style={{
//           borderRadius: "16px",
//           boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
//           backdropFilter: "blur(0.6px)",
//           WebkitBackdropFilter: "blur(0.6px)", // Note: React automatically handles vendor prefixes, but this is still used for clarity and compatibility
//           border: "1px solid rgba(255, 255, 255, 0.3)", padding: '20px', marginLeft: '0px'
//         }}>
//           <p style={{
//             background: 'linear-gradient(white, white) padding-box, linear-gradient(to right, rgb(255, 0, 0) 30px, rgb(0,0,0) 70%, rgba(255, 255, 255, 0.804)) border-box',
//             borderBottom: '2px solid transparent',
//             // borderTop: '2px solid transparent',
//             // borderTop: 'none',
//             borderLeft: 'none',
//             borderRight: 'none',
//             borderBottomRightRadius: '30px',
//             padding: '5px', fontSize: '.9rem', fontWeight: '400',
//           }}>Appliances</p>
//           <div class="row">
//             <div class="col-md-6">
//               <Simple_product product={{ src: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/refrigerator-1536x1536.png', title: 'Refrigerator', category: 'Refrigerator' }} />
//             </div>
//             <div class="col-md-6">
//               <Simple_product product={{ src: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/microwave-oven-1536x1536.png', title: 'Microwave Oven', category: 'Microwave Oven' }} />
//             </div>

//           </div>
//           <div class="row">
//             <div class="col-md-6">
//               <Simple_product product={{ src: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/air-conditioner-1536x1536.png', title: 'Air Conditioner', category: 'Air Conditioner' }} />
//             </div>
//             <div class="col-md-6">
//               <Simple_product product={{ src: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/washing-machine-7-1536x1536.png', title: 'Washing Machine', category: 'Washing Machine' }} />
//             </div>

//           </div>
//         </div>
//         <div class="col-sm-6  col-md-4" style={{
//           borderRadius: "16px",
//           boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
//           backdropFilter: "blur(0.6px)",
//           WebkitBackdropFilter: "blur(0.6px)", // Note: React automatically handles vendor prefixes, but this is still used for clarity and compatibility
//           border: "1px solid rgba(255, 255, 255, 0.3)", padding: '20px', marginLeft: '0px'
//         }}>
//           <p style={{
//             background: 'linear-gradient(white, white) padding-box, linear-gradient(to right, rgb(255, 0, 0) 30px, rgb(0,0,0) 70%, rgba(255, 255, 255, 0.804)) border-box',
//             borderBottom: '2px solid transparent',
//             // borderTop: '2px solid transparent',
//             // borderTop: 'none',
//             borderLeft: 'none',
//             borderRight: 'none',
//             borderBottomRightRadius: '30px',
//             padding: '5px', fontSize: '.9rem', fontWeight: '400',
//           }}>Digital Products</p>
//           <div class="row">
//             <div class="col-md-6">
//               <Simple_product product={{ src: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/camera-1536x1536.png', title: 'Camera', category: 'Camera' }} />
//             </div>
//             <div class="col-md-6">
//               <Simple_product product={{ src: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/laptop-1536x1536.png', title: 'Laptop', category: 'Laptop' }} />
//             </div>

//           </div>
//           <div class="row">
//             <div class="col-md-6">
//               <Simple_product product={{ src: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/mobile-phones-1-1536x1536.png', title: 'Mobile', category: 'Mobile' }} />
//             </div>
//             <div class="col-md-6">
//               <Simple_product product={{ src: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/smart-watch-1536x1536.png', title: 'Smart Watch', category: 'Smart Watch' }} />
//             </div>

//           </div>
//         </div>
//       </div>
//     </div>


//   );

// };
// export default Home_page_prdoct1;


import React from "react";
import Simple_product from "./Simple_product";
import "./Home_page_prdoct1.css";

const Home_page_prdoct1 = () => {
  return (
    <div className="Home_page_prdoct1-container-container">
      <div className="Home_page_prdoct1-container">
        <div className="Home_page_prdoct1-row">
          <div className="Home_page_prdoct1-col">
            <p className="Home_page_prdoct1-category">ENTERTAINMENT</p>
            <div className="Home_page_prdoct1-row row-grid">
              <div className="Home_page_prdoct1-col-inner">
                <Simple_product
                  product={{
                    src: "tv-1024x1024.png",
                    title: "Televisions",
                    category: "TV & Home Entertainment",
                  }}
                />
              </div>
              <div className="Home_page_prdoct1-col-inner">
                <Simple_product
                  product={{
                    src: "home-theatre-1024x1024.png",
                    title: "Home Theater",
                    category: "Home Theater",
                  }}
                />
              </div>
            </div>
            <div className="Home_page_prdoct1-row row-grid">
              <div className="Home_page_prdoct1-col-inner">
                <Simple_product
                  product={{
                    src: "https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/bluetooth-speaker-1536x1536.png",
                    title: "Audio Speakers",
                    category: "Speakers",
                  }}
                />
              </div>
              <div className="Home_page_prdoct1-col-inner">
                <Simple_product
                  product={{
                    src: "https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/sound-bar-1-1536x1536.png",
                    title: "Soundbar",
                    category: "Soundbar",
                  }}
                />
              </div>
            </div>
          </div>
          <div className="Home_page_prdoct1-col">
            <p className="Home_page_prdoct1-category">APPLIANCES</p>
            <div className="Home_page_prdoct1-row row-grid">
              <div className="Home_page_prdoct1-col-inner">
                <Simple_product
                  product={{
                    src: "https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/refrigerator-1536x1536.png",
                    title: "Refrigerator",
                    category: "Refrigerator",
                  }}
                />
              </div>
              <div className="Home_page_prdoct1-col-inner">
                <Simple_product
                  product={{
                    src: "https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/microwave-oven-1536x1536.png",
                    title: "Microwave Oven",
                    category: "Microwave Oven",
                  }}
                />
              </div>
            </div>
            <div className="Home_page_prdoct1-row row-grid">
              <div className="Home_page_prdoct1-col-inner">
                <Simple_product
                  product={{
                    src: "https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/air-conditioner-1536x1536.png",
                    title: "Air Conditioner",
                    category: "Air Conditioner",
                  }}
                />
              </div>
              <div className="Home_page_prdoct1-col-inner">
                <Simple_product
                  product={{
                    src: "https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/washing-machine-7-1536x1536.png",
                    title: "Washing Machine",
                    category: "Washing Machine",
                  }}
                />
              </div>
            </div>
          </div>
          <div className="Home_page_prdoct1-col">
            <p className="Home_page_prdoct1-category">DIGITAL PRODUCTS</p>
            <div className="Home_page_prdoct1-row row-grid">
              <div className="Home_page_prdoct1-col-inner">
                <Simple_product
                  product={{
                    src: "https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/camera-1536x1536.png",
                    title: "Camera",
                    category: "Camera",
                  }}
                />
              </div>
              <div className="Home_page_prdoct1-col-inner">
                <Simple_product
                  product={{
                    src: "https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/laptop-1536x1536.png",
                    title: "Laptop",
                    category: "Laptop",
                  }}
                />
              </div>
            </div>
            <div className="Home_page_prdoct1-row row-grid">
              <div className="Home_page_prdoct1-col-inner">
                <Simple_product
                  product={{
                    src: "https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/mobile-phones-1-1536x1536.png",
                    title: "Mobile",
                    category: "Mobile",
                  }}
                />
              </div>
              <div className="Home_page_prdoct1-col-inner">
                <Simple_product
                  product={{
                    src: "https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/09/smart-watch-1536x1536.png",
                    title: "Smart Watch",
                    category: "Smart Watch",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  );
};

export default Home_page_prdoct1;
